import BenefitsManager from './BenefitsManager';

export default BenefitsManager;
